// extracted by mini-css-extract-plugin
module.exports = {"form__title":"crowdfunding_story__form__title___40AxL","form__subtitle":"crowdfunding_story__form__subtitle___2a9Z5","form__button":"crowdfunding_story__form__button___3aAl2"};